module.exports = __webpack_public_path__ + "img/donw.edfce0da.svg";